import * as CONFIG from './config';




exports.fileUpload = function (objModel) {
    // console.log("fileUpload==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPostFile('/file/upload', objModel)
            .then(function (response) {
                // console.log('fileUpload succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileUpload err==>',err);
                reject(err);
            });
    });
}

exports.fileUploadcds = function (objModel) {
    // console.log("fileUpload==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPostFile('/file/uploadcds', objModel)
            .then(function (response) {
                // console.log('fileUpload succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileUpload err==>',err);
                reject(err);
            });
    });
}

exports.photoUpload = function (objModel) {
    // console.log("photoUpload==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPostFile('/file/uploadPhoto', objModel)
            .then(function (response) {
                // console.log('photoUpload succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('photoUpload err==>',err);
                reject(err);
            });
    });
}

exports.fileDownloadAgendaItem = function (objModel) {
    // console.log("filedownloadAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadAgendafiles/' + objModel)
            .then(function (response) {
                // console.log('filedownloadAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('filedownloadAgendaItem err==>',err);
                reject(err);
            });
    });
}

exports.fileDownloadResolution = function (objModel) {
    // console.log("fileDownloadResolution==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadResolutionfiles/' + objModel)
            .then(function (response) {
                // console.log('fileDownloadResolution succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileDownloadResolution err==>',err);
                reject(err);
            });
    });
}

exports.fileDownloadCdsfiles = function (objModel) {
    // console.log("fileDownloadCdsfiles==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadCdsfiles/' + objModel)
            .then(function (response) {
                // console.log('fileDownloadCdsfiles succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileDownloadCdsfiles err==>',err);
                reject(err);
            });
    });
}

exports.fileDownloadEsignaturefiles = function (objModel) {
    // console.log("fileDownloadCdsfiles==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadEsignaturefiles/' + objModel)
            .then(function (response) {
                // console.log('fileDownloadCdsfiles succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileDownloadCdsfiles err==>',err);
                reject(err);
            });
    });
}

exports.fileDownloadArchivefiles = function (objModel) {
    // console.log("fileDownloadCdsfiles==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadArchivefiles/' + objModel)
            .then(function (response) {
                // console.log('fileDownloadCdsfiles succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('fileDownloadCdsfiles err==>',err);
                reject(err);
            });
    });
}

exports.photoDownload = function (objModel) {
    // console.log("photoDownload==>", objModel);
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetPhoto('/file/downloadPhoto/' + objModel)
            .then(function (response) {
                // console.log('photoDownload succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('photoDownload err==>', err);
                reject(err);
            });
    });
}

exports.fileDownloadMeetingMinutesFile = function (objModel) {
    // console.log("filedownloadAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadMeetingMinutesfiles/' + objModel)
            .then(function (response) {
                // console.log('filedownloadAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('filedownloadAgendaItem err==>',err);
                reject(err);
            });
    });
}


exports.fileDownloadArchivedMeetingMinutesFile = function (objModel) {
    // console.log("filedownloadAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGetFile('/file/downloadArchivedMeetingMinutesfiles/' + objModel)
            .then(function (response) {
                // console.log('filedownloadAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('filedownloadAgendaItem err==>',err);
                reject(err);
            });
    });
}


// WEBPACK FOOTER //
// ./api/fileupload.js